<!-- -------- desktop header --------- -->
<div class="header d-none d-lg-block" [ngClass]="{ scrolled: isScrolled }">
  <div class="d-flex justify-content-between align-items-center w-100 menu-header">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center w-100">
        <a class="cursor-pointer d-flex align-items-center p-0"
          routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" #navigation
          (click)="addActive($event, '')">
          <svg-icon src="/assets/images/svg-icons/logo.svg"
          [svgStyle]="{ 'width.px': '53', 'height.px': '53' }"></svg-icon>
        </a>

        <div class="menu-item d-flex align-items-center">
          <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}/staking"
          (click)="addActive($event, 'staking')" title="staking">{{ 'top_navigation.nav_staking' | translate }}</a>

          @for (item of navigations; track item) {
            <a class="mx-2" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}"
              fragment="{{ item.routeName }}" (click)="addActive($event, item.routeName)" title="{{ item.routeName }}"
            >{{ item.navName | translate }} </a>
          }

          <!-- ---------- Social network --------- -->
          <span class="ms-3 social-wrap">
            @for (item of social; track item) {
              <a href="{{ item.link }}" class="link m-0" target="_blank"
                (click)="vwoData(item)">
                <img src="{{ item.img }}" alt="{{ item.alt }}" loading="eager" />
              </a>
            }
          </span>

          <!--- buynow wallet/address --->
          @if (!walletAddress) {
            <div class="btn btn-primary ms-2" (click)="showWidget('home')">{{ 'widget.buy_now' |
            translate }}</div>
          }
          @if (walletAddress) {
            <div class="btn btn-primary ms-2" (click)="disconnect()">{{ walletAddress | trimAddress
            }}</div>
          }

          <!---language dropdown-->

          <div class="btn-group language ms-2" dropdown>
            <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center">
              <img class="flag-icon" src="./assets/images/flags/{{selectedLanguage.flag}}.svg"
                [alt]="selectedLanguage.value" loading="lazy">
                <div class="font-12 text-uppercase fw-semibold mx-1">{{ selectedLanguage.value }}</div>
                <svg-icon class="dropdown ms-2" src="./assets/images/svg-icons/angle-down.svg"
                [svgStyle]="{ 'width.px': '14', 'height.px': '22' }"></svg-icon>
              </div>

              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                @for (lang of languagesList; track lang) {
                  <li class="cursor-pointer" role="menuitem"
                    [ngClass]="{'active': selectedLanguage.value === lang.value}">
                    @if (!isStaking) {
                      <a routerLink="/{{lang.value === 'en' ? '' : lang.value}}"
                        [fragment]="hashKey || undefined" class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                        <img src="./assets/images/flags/{{ lang.flag }}.svg" [alt]="lang.native_name + 'flag'"
                          loading="lazy" />
                          <span class="font-16 fw-normal letter-spacing-0">{{ lang.native_name }}</span>
                        </a>
                      }
                      @if (isStaking) {
                        <a routerLink="/{{lang.value === 'en' ? '' : lang.value}}/staking"
                          class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                          <img src="./assets/images/flags/{{ lang.flag }}.svg" [alt]="lang.native_name + 'flag'"
                            loading="lazy" />
                            <span class="font-16 fw-normal letter-spacing-0">{{ lang.native_name }}</span>
                          </a>
                        }
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- -------- mobile header --------- -->

      <div class="header d-block d-lg-none" [ngClass]="{ scrolled: isScrolled }">
        <div class="d-flex justify-content-between align-items-center flex-grow-1 w-100">
          <div class="d-flex justify-content-start align-items-center">
            <a class="cursor-pointer p-0" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}"
              (click)="openCloseMenu()" #navigation>
              <svg-icon src="/assets/images/svg-icons/logo.svg"
              [svgStyle]="{ 'width.px': '50', 'height.px': '50' }"></svg-icon>
            </a>
          </div>

          <div class="menu-btn" (click)="openCloseMenu()">
            <svg-icon src="./assets/images/svg-icons/{{ showMenu ? 'close-white' : 'burger-icon' }}.svg"
            [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
          </div>
        </div>

        @if (showMenu) {
          <div class="menu-overlay">
            <div class="sub-menu pull-left" [ngClass]="{ open: openMenu }">
              <!--- menu links-->
              <div class="d-flex flex-column justify-content-start align-items-start w-100">
                <a class="" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}/staking" title="staking"
                (click)="openCloseMenu()" routerLinkActive="active">{{ 'top_navigation.nav_staking' | translate }}</a>
                @for (item of navigations; track item) {
                  <a class="" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}"
                    fragment="{{ item.routeName }}" (click)="addActive($event, item.routeName); openCloseMenu()"
                  title="{{ item.routeName }}">{{ item.navName | translate }} </a>
                }
              </div>
              <!--- social links --->
              <span class="social-wrap d-flex align-items-center justify-content-center">
                @for (item of social; track item) {
                  <a href="{{ item.link }}" target="_blank" (click)="vwoData(item)">
                    <img src="{{ item.img }}" alt="{{ item.alt }}" loading="lazy" />
                  </a>
                }
              </span>
              <!---language dropdown-->
              <div class="btn-group language my-3" dropdown>
                <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center justify-content-between">
                  <div>
                    <img class="flag-icon" src="./assets/images/flags/{{selectedLanguage.flag}}.svg"
                      [alt]="selectedLanguage.value" loading="lazy">
                      <span class="ms-1 font-16 text-uppercase fw-semi-bold ms-2">{{ selectedLanguage.value }}</span>
                    </div>
                    <svg-icon class="dropdown" src="./assets/images/svg-icons/down-arrow.svg"
                    [svgStyle]="{ 'width.px': '20', 'height.px': '20' }"></svg-icon>
                  </div>
                  <ul *dropdownMenu class="dropdown-menu dropdown-menu-left" role="menu">
                    @for (lang of languagesList; track lang) {
                      <li class="p-0 cursor-pointer" role="menuitem"
                        [ngClass]="{'active': selectedLanguage.value === lang.value}">
                        @if (!isStaking) {
                          <a routerLink="/{{lang.value === 'en' ? '' : lang.value}}" (click)="openCloseMenu()"
                            class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                            <img src="./assets/images/flags/{{ lang.flag }}.svg" [alt]="lang.native_name + 'flag'" loading="lazy" />
                            <span class="font-16 fw-normal letter-spacing-0 text-capitalize">{{ lang.native_name }}</span>
                          </a>
                        }
                        @if (isStaking) {
                          <a routerLink="/{{lang.value === 'en' ? '' : lang.value}}/staking"
                            (click)="openCloseMenu()" class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                            <img src="./assets/images/flags/{{ lang.flag }}.svg" [alt]="lang.native_name + 'flag'" loading="lazy" />
                            <span class="font-16 fw-normal letter-spacing-0 text-capitalize">{{ lang.native_name }}</span>
                          </a>
                        }
                      </li>
                    }
                  </ul>
                </div>
                @if (!walletAddress) {
                  <div class="btn btn-secondary mt-4 mx-auto" (click)="showWidget('home'); openCloseMenu()">
                  {{ 'widget.buy_now' | translate }}</div>
                }
                @if (walletAddress) {
                  <div class="btn btn-secondary mt-4 mx-auto" (click)="disconnect(); openCloseMenu()">{{
                  walletAddress | trimAddress }}</div>
                }
              </div>
            </div>
          }
        </div>